"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extend = void 0;
function extend(env, name, values) {
    return new Map([...env, [name, values]]);
}
exports.extend = extend;
//# sourceMappingURL=env-extend.js.map